const sizes = {
    small: 'small',
    normal: 'normal',
};
export default sizes;
